import { ContactSection as OriginalComponent } from './ContactSection';

export const ContactSection = OriginalComponent;



// WEBPACK FOOTER //
// ./app/components/ContactSection/index.js